export default __webpack_public_path__ + "static/media/Ancestry.fcdb747b.png";